module.exports = __webpack_public_path__ + "img/homepage.ef7b0a58.png";